<template>
  <div>
    <PageHead title="退休人员信息"></PageHead>
    <div class="retiree oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">姓名：</div>
              <a-input
                allowClear
                placeholder="请输入姓名"
                v-model="queryForm.fullName"
                class="w200"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">身份证号码：</div>
              <a-input
                allowClear
                placeholder="请输入身份证号码"
                class="w200"
                v-model="queryForm.idCardNumber"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">年龄：</div>
              <a-input-number
                :min="0"
                :max="999999999"
                placeholder="请输入年龄"
                class="w200"
                v-model="queryForm.age"
                type="number"
              />
            </div>
          </div>
          <blank height="30"> </blank>
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">职级：</div>
              <a-select
                allowClear
                class="w200"
                placeholder="不限"
                v-model="queryForm.positionLevel"
              >
                <a-select-option
                  v-for="item in positionLevelList"
                  :value="item.valuename"
                  :key="item.id"
                >
                  {{ item.keyname }}</a-select-option
                >
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">性别：</div>
              <a-select
                class="w200"
                allowClear
                placeholder="不限"
                v-model="queryForm.sex"
              >
                <a-select-option value="男"> 男 </a-select-option>
                <a-select-option value="女"> 女 </a-select-option>
              </a-select>
            </div>

            <div class="query-view">
              <div class="query-view-lable">政治面貌：</div>
              <a-select
                allowClear
                class="w200"
                placeholder="不限"
                v-model="queryForm.politicalType"
              >
                <a-select-option
                  v-for="item in politicalTypeList"
                  :value="item.valuename"
                  :key="item.id"
                >
                  {{ item.keyname }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <blank height="30"> </blank>
          <div class="query-cont">
            <div class="query-view">
              <div class="query-view-lable">行政职务：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.position"
              >
                <a-select-option
                  v-for="item in positionList"
                  :value="item.valuename"
                  :key="item.id"
                >
                  {{ item.keyname }}</a-select-option
                >
              </a-select>
            </div>
            <div class="query-view">
              <div class="query-view-lable">总工龄：</div>
              <a-input
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.totalSystemAge"
              />
            </div>
            <div class="query-view">
              <div class="query-view-lable">党龄：</div>
              <a-input
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.partyAge"
              />
            </div>
          </div>
          <blank height="30"> </blank>
        </div>
        <div class="search-flex-item mb20">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <prompts>
        <span>符合此查询条件的有{{ total }}人</span>
        <a-button type="primary" size="small" class="ml20" @click="showModal()"
          >批量导出</a-button
        >
      </prompts>
      <blank height="20"> </blank>
      <!-- 花名册列表 -->
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="personList"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="position" slot-scope="text">{{
          getByTypeName(text, positionList)
        }}</span>
        <span slot="politicalType" slot-scope="text">{{
          getByTypeName(text, politicalTypeList)
        }}</span>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
      <a-modal
        v-model="visible"
        title="批量导出"
        @ok="ExportList"
        width="600px"
      >
        <prompts>
          请选择导出字段，姓名和身份证号为必选字段，其他字段可以手选
        </prompts>
        <div class="operating-checkbox">
          <a-checkbox v-model="checkAll" @change="onCheckAllChange">
            全选
          </a-checkbox>
          <blank height="10"> </blank>
          <a-checkbox-group
            v-model="excelHeader"
            :options="plainOptions"
            @change="excelHeaderonChange"
          >
            <a-checkbox
              v-for="(item, index) in plainOptions"
              :key="index"
              :value="item.value"
            >
              {{ item.label }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </a-modal>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
import { retireList, retireListExport } from './api/api'
import { mapState, mapActions } from 'vuex'
import staticData from './staticData/staticData'
export default {
  data() {
    return {
      visible: false,
      value: 5,
      columns: staticData.retireeColumns1,
      queryForm: {}, //搜索项
      personList: [], // 人事花名册列表
      excelHeader: [], //导出对应字段value
      excelHeaderKey: [], //导出对应标题label
      checkAll: false,
      page: 1,
      total: 0,
      size: 10,
      loading: false,
      plainOptions: staticData.retireePlainOptions1 // 退休人员管理 批量导出头
    }
  },
  computed: {
    ...mapState({
      // plainOptions: (state) => state.app.plainOptions, //Excel导出头
      positionList: (state) => state.bytype.positionList, //行政职务
      positionLevelList: (state) => state.bytype.positionLevelList, //职级
      politicalTypeList: (state) => state.bytype.politicalTypeList //政治面貌
    }),
    allexcelHeader: function () {
      // `this` 指向 vm 实例
      // 全选
      let Header = []
      for (const value of this.plainOptions) {
        Header.push(value.value)
      }
      return Header
    }
  },
  created() {
    this.load()
    this.getByType()
  },
  methods: {
    ...mapActions(['getposition', 'getpositionLevel', 'getpoliticalType']),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 获取当前页面所需字典表
    getByType() {
      //行政职务
      this.getposition()
      //职级
      this.getpositionLevel()
      //政治面貌
      this.getpoliticalType()
    },
    //取消
    cancel() {
      this.queryForm = {}
    },
    //搜索
    subMit() {
      this.load()
    },
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      retireList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.personList = res.data.data
          this.total = res.data.count
        }
      })
    },
    showModal() {
      this.visible = true
    },
    onCheckAllChange(e) {
      if (e.target.checked) {
        // 全选
        this.excelHeader = this.allexcelHeader
      } else {
        this.excelHeader = []
      }
    },
    excelHeaderonChange() {
      //判断是否全选
      if (this.excelHeader.length == this.allexcelHeader.length) {
        //全部选择
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    ExportList() {
      // 批量导出
      let Header = []
      for (const value of this.excelHeader) {
        let name = this.getexcelHeaderKey(value)
        Header.push(name.label)
      }
      this.excelHeaderKey = Header
      // console.log(this.excelHeader, this.excelHeaderKey)
      let params = this.queryForm
      params.excelHeader = 'fullName,idCardNumber,' + this.excelHeader.join(',') // 对应字段
      params.excelHeaderKey = '姓名,身份证号,' + this.excelHeaderKey.join(',') // 标题
      delete params.size
      delete params.page
      // 导出
      retireListExport(params).then((response) => {
        this.visible = false
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = '人事花名册查询导出.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    getexcelHeaderKey(value) {
      // 根据excelHeader获取excelHeaderKey
      return this.plainOptions.find((obj) => {
        if (obj.value == value) {
          return obj
        }
      })
    },

    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 200px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        .query-view-lable {
          width: 90px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 10px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.operating-steps {
  color: rgba(230, 247, 255, 1);
  background-color: rgba(230, 247, 255, 1);
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  .retiree-clear-img {
    width: 20px;
    height: 20px;
  }
  .retiree-clear-num {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
  .operating-steps-item {
    // height: 35px;
    line-height: 35px;
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    text-align: left;
  }
  .operating-steps-item1 {
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    text-align: left;
  }
}
.xlsx {
  width: 204px;
  height: 22px;
  margin: 32px 25px;
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.xlsx-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.operating-day {
  margin-left: 38px;
}
</style>
<style lang="scss">
.operating-checkbox {
  margin: 20px 10px;
  .ant-checkbox-group-item {
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/retiree.vue